function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { Slider } from "./Slider";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * Wraps <https://ouihealth.atlassian.net/browse/APPCORE-125> in accessibility
 * logic.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-124}
 */ export function SliderInput(props) {
    var _props_labels, _props_labels1, _props_labels2, _props_labels3;
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(props.value || props.minValue), 2), currentValue = _useState[0], setCurrentValue = _useState[1];
    var sliderRef = useRef(null);
    var _props_arialabel, _props_testID;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(View, {
                accessible: true,
                role: "slider",
                "aria-label": props.minLabel && props.maxLabel ? "".concat((_props_arialabel = props['aria-label']) !== null && _props_arialabel !== void 0 ? _props_arialabel : '', " Slider from ").concat(props.minLabel, " to ").concat(props.maxLabel) : undefined,
                "aria-valuemin": props.minValue,
                "aria-valuemax": props.maxValue,
                "aria-valuenow": currentValue,
                accessibilityActions: [
                    {
                        name: 'increment',
                        label: 'increment'
                    },
                    {
                        name: 'decrement',
                        label: 'decrement'
                    }
                ],
                onAccessibilityAction: function(event) {
                    switch(event.nativeEvent.actionName){
                        case 'increment':
                            {
                                var _sliderRef_current;
                                var newValue = Math.min(currentValue + 1, props.maxValue);
                                (_sliderRef_current = sliderRef.current) === null || _sliderRef_current === void 0 ? void 0 : _sliderRef_current.setValue(newValue);
                                setCurrentValue(newValue);
                                props.onChangeValue(newValue);
                                break;
                            }
                        case 'decrement':
                            {
                                var _sliderRef_current1;
                                var newValue1 = Math.max(currentValue - 1, props.minValue);
                                (_sliderRef_current1 = sliderRef.current) === null || _sliderRef_current1 === void 0 ? void 0 : _sliderRef_current1.setValue(newValue1);
                                setCurrentValue(newValue1);
                                props.onChangeValue(newValue1);
                                break;
                            }
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            alignItems: 'center',
                            marginBottom: 8
                        },
                        children: /*#__PURE__*/ _jsx(Text, {
                            "aria-live": "polite",
                            role: ((_props_labels = props.labels) === null || _props_labels === void 0 ? void 0 : _props_labels[currentValue]) ? undefined : 'none',
                            "aria-label": ((_props_labels1 = props.labels) === null || _props_labels1 === void 0 ? void 0 : _props_labels1[currentValue]) ? "Current value: ".concat((_props_labels2 = props.labels) === null || _props_labels2 === void 0 ? void 0 : _props_labels2[currentValue]) : undefined,
                            text: ((_props_labels3 = props.labels) === null || _props_labels3 === void 0 ? void 0 : _props_labels3[currentValue]) || ' ',
                            weight: "semibold",
                            size: 17,
                            color: theme.color.dark
                        })
                    }),
                    /*#__PURE__*/ _jsx(Slider, {
                        ref: sliderRef,
                        testID: (_props_testID = props.testID) !== null && _props_testID !== void 0 ? _props_testID : 'ChatInputSlider_slider',
                        step: props.step,
                        minimumValue: props.minValue,
                        maximumValue: props.maxValue,
                        value: currentValue,
                        onValueChange: function(val) {
                            setCurrentValue(val);
                            props.onChangeValue(val);
                        }
                    })
                ]
            }),
            props.showMinMaxValues || props.displayStyle === 'both' || props.displayStyle === 'value' ? /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between',
                    marginTop: -4
                },
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: props.minValue.toString(),
                        size: 15,
                        color: theme.color.gray300
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: props.maxValue.toString(),
                        size: 15,
                        color: theme.color.gray300
                    })
                ]
            }) : null,
            props.displayStyle === 'both' || props.displayStyle === 'label' ? /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    justifyContent: 'space-between'
                },
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: props.minLabel || ' ',
                        size: 15,
                        color: theme.color.gray300
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        text: props.maxLabel || ' ',
                        size: 15,
                        color: theme.color.gray300
                    })
                ]
            }) : null
        ]
    });
}
